exports.components = {
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-templates-shop-jsx": () => import("./../../../src/templates/shop.jsx" /* webpackChunkName: "component---src-templates-shop-jsx" */)
}

